<template>
  <div class="modal fade" id="infoFirma" tabindex="-1" aria-labelledby="infoFirma" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modalFirma">
      <div class="modal-content">
        <div class="modal-header">
          <img class="aereoPopup" src="https://www.rimborsoalvolo.it/cresources/outform/images/aereoPopup.svg">
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <h2>Firma del mandato. </h2>
          <p>Utilizzando l'apposito spazio, è possibile disegnare la propria firma e quindi autorizzare Rimborso al Volo a gestire la pratica per la richiesta del rimborso. Firmare è molto semplice e puoi farlo da qualunque dispositivo e con lo strumento che preferisci.
          </p>
        </div>
        <div class="row p-3 ">
          <div class="col-lg-3 col-6 mouse ">
            <p>
              <b>Mouse</b><br>
              su PC/Mac
            </p>
            <img class="ticketAereo" src="https://www.rimborsoalvolo.it/cresources/outform/images/mouse.svg">
          </div>
          <div class="col-lg-3 col-6 penna">
            <p>
              <b>Penna grafica</b><br>
              su mobile <br>PC/Mac
            </p>
            <img class="ticketAereo" src="https://www.rimborsoalvolo.it/cresources/outform/images/penna.svg">
          </div>
          <div class="col-lg-3 col-6 dito">
            <p><b>Con il dito</b><br>
              su mobile</p>
            <img class="ticketAereo" src="https://www.rimborsoalvolo.it/cresources/outform/images/dito.svg">
          </div>
          <div class="col-lg-3 col-6 cancellaFirma">
            <p>
              <b>Cancella firma</b><br>
              Nel caso non fossi contento/a della firma, puoi sempre cancellare e riprovare. Trovi questa opzione in basso,sotto l'area di firma.
            </p>
            <img class="ticketAereo" src="https://www.rimborsoalvolo.it/cresources/outform/images/cancellaFirma.png">
          </div>


        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "PopupFirma"
}
</script>

<style scoped>
.u-dialog-section-10 {
  min-height: 500px;
}

.u-dialog-section-10 .u-dialog-1 {
  width: 902px;
  height: auto;
  min-height: 517px;
  margin: 60px auto;
}

.u-dialog-section-10 .u-container-layout-1 {
  padding: 0;
}

.u-dialog-section-10 .u-group-1 {
  margin-top: 0;
  margin-bottom: 0;
  min-height: 55px;
  width: 100%;
}

.u-dialog-section-10 .u-container-layout-2 {
  padding: 0 30px;
}

.u-dialog-section-10 .u-image-1 {
  width: 142px;
  height: 63px;
  margin: -7px auto -2px 0;
}

.u-dialog-section-10 .u-text-1 {
  font-size: 1.875rem;
  font-weight: 600;
  margin: 28px auto 0 30px;
}

.u-dialog-section-10 .u-text-2 {
  font-size: 0.875rem;
  margin: 20px 30px 0;
}

.u-dialog-section-10 .u-layout-wrap-1 {
  width: 842px;
  margin: 44px auto 0;
}

.u-dialog-section-10 .u-layout-cell-1 {
  min-height: 241px;
}

.u-dialog-section-10 .u-container-layout-3 {
  padding: 30px;
}

.u-dialog-section-10 .u-text-3 {
  font-size: 0.875rem;
  margin: 0;
}

.u-dialog-section-10 .u-image-2 {
  width: 76px;
  height: 92px;
  margin: 30px auto 0;
}

.u-dialog-section-10 .u-layout-cell-2 {
  min-height: 241px;
}

.u-dialog-section-10 .u-container-layout-4 {
  padding: 30px;
}

.u-dialog-section-10 .u-text-4 {
  font-size: 0.875rem;
  margin: 0;
}

.u-dialog-section-10 .u-image-3 {
  width: 94px;
  height: 92px;
  margin: 30px auto 0;
}

.u-dialog-section-10 .u-layout-cell-3 {
  min-height: 241px;
}

.u-dialog-section-10 .u-container-layout-5 {
  padding: 30px;
}

.u-dialog-section-10 .u-text-5 {
  font-size: 0.875rem;
  margin: 0;
}

.u-dialog-section-10 .u-image-4 {
  width: 76px;
  height: 97px;
  margin: 30px auto 0;
}

.u-dialog-section-10 .u-layout-cell-4 {
  min-height: 241px;
}

.u-dialog-section-10 .u-container-layout-6 {
  padding: 30px;
}

.u-dialog-section-10 .u-text-6 {
  font-size: 0.875rem;
  line-height: 1;
  margin: 0;
}

.u-dialog-section-10 .u-icon-1 {
  width: 64px;
  height: 64px;
  margin: 9px auto 0;
}

.u-dialog-section-10 .u-icon-2 {
  width: 20px;
  height: 20px;
  left: auto;
  top: 15px;
  position: absolute;
  right: 20px;
}

@media (max-width: 1399px) {
  .u-dialog-section-10 .u-image-1 {
    height: 64px;
  }

  .u-dialog-section-10 .u-text-3 {
    margin-left: 0;
    margin-right: 0;
  }

  .u-dialog-section-10 .u-image-2 {
    width: 76px;
    height: 91px;
  }

  .u-dialog-section-10 .u-text-4 {
    margin-left: 0;
    margin-right: 0;
  }

  .u-dialog-section-10 .u-image-3 {
    width: 94px;
    height: 91px;
  }

  .u-dialog-section-10 .u-text-5 {
    margin-left: 0;
    margin-right: 0;
  }

  .u-dialog-section-10 .u-image-4 {
    width: 76px;
    height: 97px;
  }

  .u-dialog-section-10 .u-text-6 {
    margin-left: 0;
    margin-right: 0;
  }
}

@media (max-width: 1199px) {
  .u-dialog-section-10 .u-image-1 {
    height: 63px;
  }

  .u-dialog-section-10 .u-text-3 {
    margin-left: 0;
    margin-right: 0;
  }

  .u-dialog-section-10 .u-image-2 {
    width: 76px;
    height: 92px;
  }

  .u-dialog-section-10 .u-text-4 {
    margin-left: 0;
    margin-right: 0;
  }

  .u-dialog-section-10 .u-image-3 {
    width: 94px;
    height: 92px;
  }

  .u-dialog-section-10 .u-text-5 {
    margin-left: 0;
    margin-right: 0;
  }

  .u-dialog-section-10 .u-image-4 {
    width: 76px;
    height: 97px;
  }

  .u-dialog-section-10 .u-text-6 {
    margin-left: 0;
    margin-right: 0;
  }
}

@media (max-width: 991px) {
  .u-dialog-section-10 .u-dialog-1 {
    width: 720px;
  }

  .u-dialog-section-10 .u-text-2 {
    width: auto;
  }

  .u-dialog-section-10 .u-layout-wrap-1 {
    width: 680px;
  }

  .u-dialog-section-10 .u-layout-cell-1 {
    min-height: 259px;
  }

  .u-dialog-section-10 .u-layout-cell-2 {
    min-height: 259px;
  }

  .u-dialog-section-10 .u-image-3 {
    width: 84px;
    height: 82px;
  }

  .u-dialog-section-10 .u-layout-cell-3 {
    min-height: 259px;
  }

  .u-dialog-section-10 .u-layout-cell-4 {
    min-height: 259px;
  }
}

@media (max-width: 767px) {
  .u-dialog-section-10 {
    min-height: 95px;
  }

  .u-dialog-section-10 .u-dialog-1 {
    width: 540px;
    min-height: 771px;
  }

  .u-dialog-section-10 .u-container-layout-1 {
    padding-bottom: 19px;
  }

  .u-dialog-section-10 .u-group-1 {
    width: 540px;
    margin-left: 0;
    margin-right: 0;
  }

  .u-dialog-section-10 .u-container-layout-2 {
    padding-left: 10px;
    padding-right: 10px;
  }

  .u-dialog-section-10 .u-image-1 {
    width: 80px;
    height: 35px;
  }

  .u-dialog-section-10 .u-layout-wrap-1 {
    width: 480px;
  }

  .u-dialog-section-10 .u-layout-cell-1 {
    min-height: 226px;
  }

  .u-dialog-section-10 .u-container-layout-3 {
    padding-left: 10px;
    padding-right: 10px;
  }

  .u-dialog-section-10 .u-layout-cell-2 {
    min-height: 216px;
  }

  .u-dialog-section-10 .u-container-layout-4 {
    padding-left: 10px;
    padding-right: 10px;
  }

  .u-dialog-section-10 .u-layout-cell-3 {
    min-height: 231px;
  }

  .u-dialog-section-10 .u-container-layout-5 {
    padding-left: 10px;
    padding-right: 10px;
  }

  .u-dialog-section-10 .u-layout-cell-4 {
    min-height: 189px;
  }

  .u-dialog-section-10 .u-container-layout-6 {
    padding: 27px 10px;
  }

  .u-dialog-section-10 .u-text-6 {
    width: auto;
  }

  .u-dialog-section-10 .u-icon-1 {
    margin-top: 25px;
  }
}

@media (max-width: 575px) {
  .u-dialog-section-10 .u-dialog-1 {
    width: 340px;
  }

  .u-dialog-section-10 .u-group-1 {
    width: 340px;
  }

  .u-dialog-section-10 .u-text-2 {
    margin-right: 0;
  }

  .u-dialog-section-10 .u-layout-wrap-1 {
    width: 340px;
  }

  .u-dialog-section-10 .u-layout-cell-1 {
    min-height: 100px;
  }

  .u-dialog-section-10 .u-layout-cell-2 {
    min-height: 100px;
  }

  .u-dialog-section-10 .u-layout-cell-3 {
    min-height: 100px;
  }

  .u-dialog-section-10 .u-layout-cell-4 {
    min-height: 100px;
  }
}
</style>